import React from 'react';
import { Paper, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PROFILE_HEIGHT } from '../../../../constants/Layout';

import ProfileInfo from '../../desktop/navigationMenu/ProfileInfo';

const useStyles = makeStyles(() => ({
  root: {
    height: PROFILE_HEIGHT,
  },
}));

const Profile = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <Box display="flex" justifyContent="center" alignItems="center">
        <ProfileInfo />
      </Box>
    </Paper>
  );
};

export default Profile;
